export default __webpack_public_path__ + "static/media/twitter.24f63ee4.svg";